import { useTranslation } from "react-i18next";
import { Suspense, useRef, useState } from "react";
import AppLoading from "../app-loading/app-loading";
import { Toast } from "primereact/toast";
import PosStockSummarySearch from "./PosStockSummarySearch";
import PosStockSummaryDatatable from "./PosStockSummaryDatatable";
import posService from "../../services/pos/pos.service";
import { ProductStockSummary } from "../../models/pos/product-stock-summary-model";

const PosProductStockSummary = () => {
  const { t } = useTranslation();
  const toast = useRef<Toast>(null);
  const [filteredProducts, setFilteredProducts] = useState<ProductStockSummary[]>([]);
  const [productList, setProductList] = useState<ProductStockSummary[]>([]);
  const [loading, setLoading] = useState(false);
  const [activeStatusFilters, setActiveStatusFilters] = useState<string[]>([]);
  const [keywordsearch, setKeywordsearch] = useState<string>("");
  const [posIdS, setPosId] = useState<number[]>([]);

  const getAllProductStockSummary = (posId: any) => {
    setLoading(true);
    posId.length === 0 && setActiveStatusFilters([]);
    
    posService.getProductStockSummary(posId).then((response) => {
      setProductList(response || []);
      let statusFilteredProducts = response || [];
      
      if (activeStatusFilters.length > 0) {
        statusFilteredProducts = statusFilteredProducts.filter(
          (product: any) => activeStatusFilters.includes(product.status)
        );
      }
      
      if (keywordsearch && keywordsearch.trim() !== "") {
        statusFilteredProducts = statusFilteredProducts.filter(
          (product: any) =>
            product.productName.toLowerCase().includes(keywordsearch.toLowerCase())
        );
      }
      
      activeStatusFilters.length > 0 || keywordsearch.trim() !== ""
        ? setFilteredProducts(statusFilteredProducts)
        : setFilteredProducts(response || []);
      
      setLoading(false);
    }).catch((error) => {
      console.error("Error fetching product stock summary:", error);
      setLoading(false);
      showMessage("Error", "Failed to fetch product stock summary", "error");
    });
  };

  function handleSearch(query: string): void {
    setLoading(true);
    setKeywordsearch(query);
    if (productList && productList.length > 0) {
      const searchedProducts = productList.filter(
        (product) =>
          product.productName &&
          typeof product.productName === "string" &&
          product.productName.toLowerCase().includes(query.toLowerCase())
      );
      setFilteredProducts(searchedProducts);
    } else {
      setFilteredProducts([]);
    }
    setTimeout(() => setLoading(false), 200);
  }

  const handlePOSChange = (posId: any) => {
    setLoading(true);
    setPosId(posId);
    getAllProductStockSummary(posId);
  };

  const handleAddSuccess = (posId: number[]) => {
    getAllProductStockSummary(posIdS); // refresh after adding
  };

  // called by search component when status checkboxes change
  const handleStatusChange = (statuses: string[]) => {
    const filteredStatus = productList.filter((product) =>
      statuses.includes(product.status)
    );
    statuses.length > 0 ? setFilteredProducts(filteredStatus) : setFilteredProducts(productList);
    setActiveStatusFilters(statuses);
  };

  const showMessage = (summary: string, detail: string, severity: any) => {
    toast.current?.show({
      severity,
      summary,
      detail,
      life: 3000,
    });
  };

  return (
    <>
      <Suspense fallback={<AppLoading />}>
        <Toast ref={toast} position="top-right" />
        <div className="layout-content mt-3 mb-3 grid grid-table-mobile">
          <div className="col-12">
            <h5 className="ml-1 mb-0">{t("POS Inventory Master")}</h5>
          </div>
          <div className="col-12">
            <div className="flex align-items-center justify-content-between flex-wrap gap-2 w-full card-container mb-0">
              <PosStockSummarySearch
                onSearch={handleSearch}
                setLoading={setLoading}
                onPOSChange={handlePOSChange}
                onAddSuccess={handleAddSuccess}
                onStatusFilterChange={handleStatusChange}
              />
            </div>
          </div>
          <PosStockSummaryDatatable
            data={filteredProducts}
            onRefresh={handleAddSuccess}
            setLoading={setLoading}
            selectedPosIds={posIdS}
          />
        </div>
        {loading && <AppLoading />}
      </Suspense>
    </>
  );
};

export default PosProductStockSummary;
